import React, { useState, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";
import { useIntl, defineMessages } from "react-intl";
import { TextField, CircularProgress, Modal } from "@material-ui/core";

import { incompleteTaskWithReason, fetchWorkorder } from "../../redux/task/taskActions";
import { requestFollowUpReasons, saveFollowUps } from "../../redux/followUps/followUpsActions";
import { setIncompleteReasonError, setIncompleteSubReasonError, setNewDueDateError } from "../../redux/workorder/workorderActions";
import WorkOrderAction from "./workOrderAction";
import { INCOMPLETE_REASON_CODES } from "../../globals/workOrderStatus";
import { uploadAttachments, fileUploadAuditActivity } from "../../redux/attachments/attachmentsActions";
import AttachmentsField from "./attachmentsField";
import { formatFilesForUpload } from "../common/attachments/attachmentsHelper";

import EditIcon from "../common/icons/editIcon";

import FormSection from "./formSection";
import FormField from "./formFields";
import FollowUpsFormField from "./followUpsField";
import FormSelect from "./formSelect";
import DatePicker from "../common/datepicker/datePicker";
import { generateMwaList } from "../../utils/generateMwaList";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";

const messages = defineMessages({
    taskIncompleteHeaderTitle: {
        id: "task-incomplete-form.header-title",
        defaultMessage: "Incomplete job",
        description: "Incomplete task form title",
    },
    additionalDetailsSectionTitle: {
        id: "task-incomplete-form.additional-details-section-title",
        defaultMessage: "Additional details",
        description: "Additional details",
    },
    addYourComments: {
        id: "task-incomplete-form.add-your-comments",
        defaultMessage: "Add your comments here",
        description: "Add your comments here caption",
    },
    attachmentsSectionTitle: {
        id: "task-complete-form.attachments-section-title",
        defaultMessage: "Attachments",
        description: "Attachments section title",
    },
    doneButtonText: {
        id: "task-incomplete-form.done-button-label",
        defaultMessage: "Done",
        description: "Done Button label",
    },
    incompleteReasonTitle: {
        id: "task-incomplete-form.incomplete-reason",
        defaultMessage: "Incomplete reason",
        description: "Incomplete reason",
    },
    incompleteSubReasonTitle: {
        id: "task-incomplete-form.incomplete-sub-reason",
        defaultMessage: "Incomplete sub-reason",
        description: "Incomplete reason",
    },
    incompleteDate: {
        id: "task-incomplete-form.date-caption",
        defaultMessage: "Date",
        description: "Date caption",
    },
    labourerComments: {
        id: "task-incomplete-form.labourer-comments",
        defaultMessage: "Labourer comments",
        description: "Labourer comments caption",
    },
    selectStart: {
        id: "task-incomplete-form.select-start-datetime-caption",
        defaultMessage: "Start date \u0026 time",
        description: "Assign resource start datetime caption",
    },
    followUpsSectionTitle: {
        id: "task-complete-form.follow-ups-section-title",
        defaultMessage: "Follow-ups (if applicable)",
        description: "Follow-ups section title",
    },
});

export const TaskIncomplete = (props) => {
    const intl = useIntl();
    const history = useHistory();
    const { workOrderNumber } = useParams();
    const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false);

    const reasonIdsNeedingDatePicker = [INCOMPLETE_REASON_CODES.CUSTOMER_REQUESTED_DIFF_DAY];
    const [submitting, setSubmitting] = React.useState(false);
    const [useDatePicker, setUseDatePicker] = useState(false);
    const [subReasons, setSubReasons] = React.useState(props.subreasons);
    const taskId = props.workorderData && props.workorderData.id ? props.workorderData.id : null;
    const [uploadFlag, setUploadFlag] = useState(false);
    const [auditActionComplete, setAuditActionComplete] = useState(false);
    const [latestFollowUps, setLatestFollowUps] = useState([]);
    const { activityQuestions } = useActivityQuestions();
    const formateDate = (iDate) => (iDate ? moment(moment(iDate)).utc().format("YYYY-MM-DD HH:mm:00") : "");

    const [data, setData] = React.useState({
        date: new Date(),
        incompleteReason: null,
        newDueDate: null,
        incompleteSubReason: null,
        labourerComments: null,
        incompleteFollowUpReason: null,
        incompleteFOllowUpSubreason: null,
        incompleteFollowUpDetails: "",
        //notificationLeft: notificationLeftOpts[1].label,
        //notifiedVia: null
    });

    useEffect(() => {
        props.fetchWorkorder(workOrderNumber);
        props.requestFollowUpReasons();
    }, [workOrderNumber]);

    useEffect(() => {
        if (submitting && (!uploadFlag || auditActionComplete)) {
            if (!props.incompleteTaskResponse) {
                setSubmitting(false);
            } else {
                history.push("/");
            }
        }
    }, [props.incompleteTaskResponse, auditActionComplete]);

    useEffect(() => {
        if (
            uploadFlag &&
            props.fileUploadResponse.length > 0 &&
            typeof props.fileUploadResponse[0] === "object" &&
            props.workOrderAttachments.length > 0
        ) {
            props.fileUploadResponse.map((file, index) => {
                const attachmentID = file.fileDownloadUri.split("/").at(-1);
                const uploadedAttachment = props.workOrderAttachments.filter((attachment) => {
                    return attachment.id === attachmentID;
                })[0];
                const payload = {
                    createdDateTime: uploadedAttachment.createdDateTime,
                    id: uploadedAttachment.id,
                    newFileDescription: "",
                    newFileName: "",
                    newFileType: "",
                    newRelatedJobId: "",
                    newRelatedSourceId: "",
                    oldFileDescription: uploadedAttachment.fileDescription,
                    oldFileName: uploadedAttachment.fileName,
                    oldFileType: uploadedAttachment.fileType,
                    oldRelatedJobId: uploadedAttachment.relatedJobId,
                    oldRelatedSourceId: uploadedAttachment.relatedSourceId,
                    originatingSystem: "CMIS",
                    uploadedBy: props.userProfile.username,
                };
                const closedFun = (payload1, index1) => {
                    setTimeout(() => {
                        props.fileUploadAuditActivity(payload1);
                    }, index1 * 3000);
                };
                closedFun(payload, index);
            });
            setUploadFlag(false);
            setAuditActionComplete(true);
        }
    }, [props.workOrderAttachments]);

    const handleReasonChange = (reason) => {
        if (!reason.parentReasonCode) {
            var newSubReasons = props.subreasons.filter((subreason) => subreason.parentReasonCode === reason.id);
            setSubReasons(newSubReasons);
            var dateUsed = reasonIdsNeedingDatePicker.includes(reason.id);
            setUseDatePicker(dateUsed);
            props.setNewDueDateError(dateUsed ? dateUsed && !data.newDueDate : dateUsed);
            props.setIncompleteReasonError(false);
            props.setIncompleteSubReasonError(newSubReasons.length !== 0); // Clear error/req for subreason if there aren't any
        } else {
            props.setIncompleteSubReasonError(false);
        }
    };
    const getDatafromChild = (data) => {
        setLatestFollowUps(data);
    };
    const handleDateChange = (value) => {
        props.setNewDueDateError(!value);
    };
    //const formateDate = (iDate) => iDate ? moment(moment(iDate)).utc().format('YYYY-MM-DD HH:mm:00') : "";
    const submit = () => {
        let err = false;
        if (!data.incompleteReason || (subReasons.length > 0 && !data.incompleteSubReason) || (useDatePicker && !data.newDueDate)) {
            err = true;
            return;
        }
        if (err) return;

        setSubmitting(true);
        const followUpDetailsIn = latestFollowUps
            ? latestFollowUps
                  .filter((followUp) => followUp)
                  .map((followUp, index) => {
                      if (followUp.isFollowUpActive) {
                          if (data[`followUps.${index}.comments`]) {
                              followUp.comments = data[`followUps.${index}.comments`];
                          }
                          return {
                              followUpTpyeId: followUp.id,
                              creationDate: formateDate(followUp.creationDate),
                              comments: followUp.comments ? followUp.comments : null,
                              id: null,
                              uuid: followUp.uuid,
                              taskId,
                              dueDate: formateDate(followUp?.dueDate),
                              validatedForDoubles: true,
                              duplicateWorkOrdersDTO: followUp?.duplicateWorkOrdersDTO ? followUp?.duplicateWorkOrdersDTO : null,
                              mwaList: generateMwaList(activityQuestions.questions, followUp, props.followUpReasons),
                          };
                      }
                  })
            : null;
        if (followUpDetailsIn && followUpDetailsIn[0] == undefined) {
            followUpDetailsIn.splice(0, 1);
        }

        const incompleteInfo = {
            scheduledDate: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
            workOrderNumber: workOrderNumber,
            reasonId: data.incompleteReason.id,
            subReasonId: data.incompleteSubReason ? data.incompleteSubReason.id : null,
            aditionalComments: data?.labourerComments,
            dueDate: useDatePicker ? props.workorderInfo.workorderData.dueDate : null,
            newDueDate: useDatePicker ? moment(data.newDueDate) : null,
            userProfile: {
                sub: props.userInfo.sub,
                email_verified: props.userInfo.email_verified,
                adGroup: ["/CmisLabourer"],
                name: props.userInfo.name,
                preferred_username: props.userInfo.preferred_username,
                given_name: props.userInfo.given_name,
                family_name: props.userInfo.family_name,
                employeeNumber: props.technicianInfo.pein,
            },
        };

        const followUpInfo = followUpDetailsIn?.length > 0 && {
            userProfile: incompleteInfo.userProfile,
            relatedID: workOrderNumber,
            followUpList: followUpDetailsIn,
        };

        const filesToBeUploaded = formatFilesForUpload(props.filesToUpload, props.workorderInfo.workorderData.clickDispatchId, workOrderNumber);

        if (filesToBeUploaded && filesToBeUploaded.length > 0) {
            props.uploadAttachments(filesToBeUploaded);
            setUploadFlag(true);
        }
        props.incompleteTaskWithReason(incompleteInfo, followUpInfo);
    };

    let reasons = props.reasons;

    return (
        <WorkOrderAction title={intl.formatMessage(messages.taskIncompleteHeaderTitle)} incomplete onSubmit={submit} data={data}>
            <Modal style={{ display: "flex", alignItems: "center", justifyContent: "center" }} open={submitting}>
                <CircularProgress />
            </Modal>
            <FormSection title={intl.formatMessage(messages.additionalDetailsSectionTitle)}>
                <FormField field="date" label={intl.formatMessage(messages.incompleteDate)} readonly />
                <FormField
                    field="incompleteReason"
                    label={intl.formatMessage(messages.incompleteReasonTitle)}
                    required
                    editorProps={{
                        icon: <EditIcon />,
                        title: intl.formatMessage(messages.incompleteReasonTitle),
                        btnText: intl.formatMessage(messages.doneButtonText),
                        editor: (props) => <FormSelect options={reasons} onSelect={(reason) => handleReasonChange(reason)} {...props} />,
                    }}
                    divider
                />
                {useDatePicker && (
                    <FormField
                        field="newDueDate"
                        required={useDatePicker}
                        label={intl.formatMessage(messages.selectStart)}
                        editorProps={{
                            icon: <EditIcon />,
                            title: intl.formatMessage(messages.incompleteReasonTitle),
                            btnText: intl.formatMessage(messages.doneButtonText),
                            editor: (props) => (
                                <DatePicker
                                    {...props}
                                    onChange={(value) => {
                                        handleDateChange(value);
                                        props.onChange({
                                            target: {
                                                value,
                                            },
                                        });
                                    }}
                                />
                            ),
                        }}
                        divider
                    />
                )}
                <FormField
                    field="incompleteSubReason"
                    label={intl.formatMessage(messages.incompleteSubReasonTitle)}
                    required={subReasons.length > 0}
                    disabled={subReasons.length == 0}
                    editorProps={{
                        icon: <EditIcon />,
                        title: intl.formatMessage(messages.incompleteSubReasonTitle),
                        btnText: intl.formatMessage(messages.doneButtonText),
                        editor: (props) => <FormSelect options={subReasons} onSelect={(reason) => handleReasonChange(reason)} {...props} />,
                    }}
                    divider
                />
                <FormField
                    field="labourerComments"
                    label={intl.formatMessage(messages.labourerComments)}
                    editorProps={{
                        icon: <EditIcon />,
                        title: intl.formatMessage(messages.labourerComments),
                        btnText: intl.formatMessage(messages.doneButtonText),
                        editor: (props) => (
                            <TextField
                                value={""}
                                id="labourer-comments"
                                placeholder={intl.formatMessage(messages.addYourComments)}
                                multiline
                                fullWidth
                                rows={4}
                                variant="outlined"
                                InputProps={{
                                    inputProps: { maxLength: 300 },
                                }}
                                {...props}
                            />
                        ),
                    }}
                    divider
                    characterCountEnabled
                />
            </FormSection>
            {process.env.REACT_APP_FEATURE_FILEUPLOAD === "true" && (
                <FormSection title={intl.formatMessage(messages.attachmentsSectionTitle)}>
                    <AttachmentsField workOrderNumber={workOrderNumber} clickDispatchId={props.workorderInfo.workorderData.clickDispatchId} />
                </FormSection>
            )}
            {process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                <FormSection title={intl.formatMessage(messages.followUpsSectionTitle)}>
                    <FollowUpsFormField
                        field="followUps"
                        openDuplicatePopup={openDuplicatePopup}
                        sendData={getDatafromChild}
                        setOpenDuplicatePopup={setOpenDuplicatePopup}
                        workOrderNumber={workOrderNumber}
                        reasons={props.followUpReasons}
                    />
                </FormSection>
            )}
        </WorkOrderAction>
    );
};

const mapStateToProps = (state) => {
    return {
        workorderInfo: state.tasks.workorderData,
        followUpReasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
        reasons: state.reasons.partialReasons.has("Incomplete")
            ? state.reasons.partialReasons.get("Incomplete").filter((reason) => !reason.parentReasonCode)
            : [],
        subreasons: state.reasons.partialReasons.has("Incomplete")
            ? state.reasons.partialReasons.get("Incomplete").filter((reason) => reason.parentReasonCode)
            : [],
        incompleteTaskResponse: state.tasks.incompleteTaskResponse,
        incompleteSubReason: state.workorder.incomplete.incompleteSubReason,
        filesToUpload: state.attachments.filesToUpload,
        userProfile: state.login.userProfile,
        userInfo: state.login.userInfo,
        technicianInfo: state.login.technicianInfo,
        workorderData: state.tasks.workorderData.workorderData,
        workOrderAttachments: state.attachments?.workOrderAttachments,
        fileUploadResponse: state.attachments?.fileUploadRes,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchWorkorder,
            requestFollowUpReasons,
            uploadAttachments,
            setIncompleteReasonError,
            setIncompleteSubReasonError,
            setNewDueDateError,
            incompleteTaskWithReason,
            fileUploadAuditActivity,
            saveFollowUps,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(TaskIncomplete);
